<template lang="html">
  <div id="home-page">

    <!-- Banners -->
    <section class="banner-section">
      <swiper class="swiper swiper-st-1 d-none d-lg-block" :options="bannersOptions">
        <swiper-slide v-for="(bd, bdInx) in banners.desktop" :key="'bdInx-'+bdInx">
          <div class="box-content">
            <img class="placed-backg d-lg-block" src="public/images/pages/home/banner.png" v-bind:style="{ backgroundImage: 'url('+bd.imageUrl+')' }">

            <!-- <div class="box-text">
              <div class="inside">
                <h3 class="title">Jugo Verde</h3>

                <h4 class="subtitle">Con vitamina C<br />prebioticos y<br />proteinas</h4>

                <div class="b-buttons">
                  <router-link class="mb-3 btn-slider st-1" target="_blank" to="/productos">Compra en línea</router-link>

                </div>
              </div>
            </div> -->
          </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <swiper class="swiper swiper-st-1 d-lg-none" :options="bannersOptions">
        <swiper-slide v-for="(bm, bmInx) in banners.movil" :key="'bmInx-'+bmInx">
          <div class="box-content">
            <img class="placed-backg d-lg-block" src="public/images/pages/home/banner-m.png" v-bind:style="{ backgroundImage: 'url('+bm.imageUrl+')' }">

            <!-- <div class="box-text">
              <div class="inside">
                <h3 class="title">Jugo Verde</h3>

                <h4 class="subtitle">Con vitamina C<br />prebioticos y<br />proteinas</h4>

                <div class="b-buttons">
                  <router-link class="mb-3 btn-slider st-1" target="_blank" to="/productos">Compra en línea</router-link>
                </div>
              </div>
            </div> -->
          </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>
    <!--  -->

    <!-- Formas de ganar -->
    <section class="win-section">
      <div class="container med-container">
        <h2 class="mb-2 text-center title-s1">3 FORMAS DE GANAR</h2>

        <div class="row justify-content-center">
          <div class="col-11 col-sm-6 col-md-5 col-lg-4 col-xl-3 col-info">
            <div class="content">
              <div class="box-icon">
                <img src="public/images/pages/home/win-1.svg">
              </div>

              <div class="box-text">
                <div class="inside">
                  <h4>OFRECER</h4>
                  <h6>[OPCIONAL]</h6>
                </div>
              </div>

              <h3 class="title">1</h3>
            </div>
          </div>

          <div class="col-11 col-sm-6 col-md-5 col-lg-4 col-xl-3 col-info">
            <div class="content">
              <div class="box-icon">
                <img src="public/images/pages/home/win-2.svg">
              </div>

              <div class="box-text">
                <div class="inside">
                  <h3>AFILIAR</h3>
                </div>
              </div>

              <h3 class="title">2</h3>
            </div>
          </div>

          <div class="col-11 col-sm-6 col-md-5 col-lg-4 col-xl-3 col-info">
            <a class="content" @click="$refs['modal-info-1'].show();">
              <div class="box-icon">
                <img src="public/images/pages/home/win-3.svg">
              </div>

              <div class="box-text">
                <div class="inside">
                  <h6>REGALÍAS</h6>
                  <h4>[CAPITALIZA-T]</h4>
                </div>
              </div>

              <h3 class="title">N1</h3>
            </a>
          </div>

          <div class="col-11 col-sm-6 col-md-5 col-lg-4 col-xl-3 col-info">
            <a class="content"  @click="$refs['modal-info-2'].show();">
              <div class="box-icon">
                <img src="public/images/pages/home/win-4.svg">
              </div>

              <div class="box-text">
                <div class="inside">
                  <h6>REGALÍAS</h6>
                  <h4>[TURBO]</h4>
                </div>
              </div>

              <h3 class="title">N2</h3>
            </a>
          </div>
        </div>

        <div class="d-block text-center mt-3">
          <div class="b-title">¡DEJA DE TRABAJAR DE MÁS Y QUE TE PAGUEN DE MENOS!</div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Productos -->
    <section class="products-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">PRODUCTOS</h2>
          </div>

          <div class="col-12 col-products">
            <swiper class="swiper carousel-t1" :options="productsOption">
              <swiper-slide v-for="(product, pInx) in products" :key="'pInx-'+pInx">
                <div class="col-12 px-0 sample-product shad-prod">
                  <a class="outlined-box">
                    <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

                    <div class="box-image">
                      <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                      <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
                        <img src="public/images/pages/products/product.png" >
                      </div>
                    </div>

                    <div class="box-shot-descr">
                      <h6 class="brand">{{ product.sku }}</h6>
                      <h6 class="name">{{ product.name }}</h6>
               
                    </div>

                    <cart-component :product="product"></cart-component>
                  </a>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Blog -->
    <section class="blog-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">NOTICIAS</h2>
          </div>

          <div class="col-12">
            <swiper class="swiper swiper-st-2" :options="blogOptions">
              <swiper-slide v-for="(ah, ahInx) in blogs" :key="'ahInx-'+ahInx">
                <div class="col-12 px-0 box-article-s1">
                  <router-link class="box" :to="'/blog/'+ah.id">
                    <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+ah.imageUrl+')' }"></div>

                    <div class="box-info">
                      <h5 class="title">{{ ah.title }}</h5>

                      <div class="b-text" v-html="ah.body_cut"></div>
                    </div>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Modal Info 1 -->
    <b-modal modal-class="modal-info-s2" ref="modal-info-1" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <p class="mb-3 text-center note"><i class="fa-solid fa-bell"></i> SE ACTIVA CUANDO TE DAS DE ALTA AL SISTEMA</p>

      <h4 class="text-center">NEGOCIO 1</h4>
      <h5 class="text-center txt-c-1">CAPITALIZACIÓN EXPRESS</h5>

      <h6 class="mt-2 text-center">COBRAS: 2 NIVELES</h6>

      <p class="f-w-600 mt-2 text-center txt-lg">Nivel 1 - $1,000</p>
      <p class="f-w-600 text-center txt-lg">Nivel 2 - $500</p>

      <ol class="mt-2 f-w-500">
        <li>
          COBRAS, TODOS LOS RECONSUMOS DE TUS AFILIADOS DE LOS 2 NIVELES, INDEFINIDAMENTE.
        </li>
        <li>
          ESTE NEGOCIO SE ALIMENTA DE NUEVOS AFILIADOS.
        </li>
      </ol>

      <p class="text-center">
        <router-link class="btn btn-s1 bg-c-primary px-5" to="/afiliate">¡AFÍLIATE!</router-link>
      </p>
    </b-modal>
    <!--  -->

    <!-- Modal Info 2 -->
    <b-modal modal-class="modal-info-s2" ref="modal-info-2" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <p class="mb-3 text-center note"><i class="fa-solid fa-bell"></i> SE ACTIVA, CON 2 CALIFICADOS DIRECTOS DEL NEGOCIO 1</p>

      <h4 class="text-center">NEGOCIO 2</h4>
      <h5 class="text-center txt-c-1">RIQUEZA TURBO</h5>

      <h6 class="mt-2 text-center">COBRAS: 3 NIVELES ADICIONALES</h6>

      <p class="f-w-600 mt-2 text-center txt-lg">Nivel 1 - $200</p>
      <p class="f-w-600 text-center txt-lg">Nivel 2 - $300</p>
      <p class="f-w-600 text-center txt-lg">Nivel 3 - $1,000</p>

      <ol class="mt-2 f-w-500">
        <li>
          SE FORMA DE TODOS LO MIGRANTES DEL NEGOCIO 1, Y LLEGAN AL MISMO NIVEL DEL NIVEL DE ORIGEN .
        </li>
        <li>
          LOS PAGOS SE REALIZAN DEL 10 AL 15 DE CADA MES PROXIMO SIGUIENTE.
        </li>
      </ol>

      <p class="text-center">
        <router-link class="btn btn-s1 bg-c-primary px-5" to="/afiliate">¡AFÍLIATE!</router-link>
      </p>
    </b-modal>
    <!--  -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: {
        desktop: [
         ],
        movil: [
        ],
      },

      products: [      ],

      blogs: [
        { imageUrl: 'public/images/pages/blog/article-1.jpg',
          title: 'Super Peso Plus. Beneficios para una para una vida saludable',
          text: `
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          `
        },
        { imageUrl: 'public/images/pages/blog/article-2.jpg',
          title: '¿Buscas llegar a tu peso ideal y mejorar tu digestión con ingredientes naturales?',
          text: `
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          `
        },
      ],

      // == Carousel options ==
      bannersOptions: {
        loop: true,
        speed: 700,
        effect: 'fade',

        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      productsOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 4,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            spaceBetween: 0,
            slidesPerView: 4
          },
          992: {
            spaceBetween: 0,
            slidesPerView: 3
          },
          768: {
            spaceBetween: 0,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: 'slide',
        speed: 600
      },

      blogOptions: {
        slidesPerView: 2,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }
      },
      // == ==
    }
  },
  methods: {
    getHome: function(){

      axios.get(tools.url('/api/home')).then(({data}) =>{
        this.banners = data.banners;
        this.products = data.products;
        this.blogs = data.blogs;
      
      });
    },
  },

  mounted() {
    this.getHome();
  }
}
</script>
